import React from 'react'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { set_start_end_date, set_disp_objects } from '../../actions/index'
import './css/airpicker.css'
const moment = require('moment')

var granularity = "date";
var pickerType = "date";
var filterToggle = false;
var startDatepicker = null, endDatepicker = null;

class CalenderComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            start: this.props.startDate,
            end: this.props.endDate,
            // monthView: false
        }
        // this.viewChangeHandle = this.viewChangeHandle.bind(this);
        this.handleDateToggle = this.handleDateToggle.bind(this);
        /* Update moment - set the start of a week acc. to the settings in general settings, default will be Monday */
        moment.updateLocale('en', {
            week: {
                dow: startOfWeek
            }
        })
    }

    componentWillReceiveProps(nextProps){
        this.handleDates(nextProps)
        const monthPicker = document.querySelector(".customMonthPicker");
        const datePicker = document.querySelector(".customDatePicker");
        if(pickerType=="month" || pickerType == 'quarter'){
            monthPicker.style.display="flex";
            datePicker.style.display="none";
        }else {
            monthPicker.style.display="none";
            datePicker.style.display="flex";
        }
        // this.setState({
        //     monthView: false
        // })
    }
    componentDidMount() {
        pickerType = this.props.granularity;
        this.handleDates(this.props)
        const monthPicker = document.querySelector(".customMonthPicker");
        const datePicker = document.querySelector(".customDatePicker");
        if(pickerType=="month" || pickerType == 'quarter'){
            monthPicker.style.display="flex";
            datePicker.style.display="none";
        }else {
            monthPicker.style.display="none";
            datePicker.style.display="flex";
        }
        // $(function() {
        //     $('#reportrange').click(function () {
        //         pickerType = "month";
        //         $('.mainBoxDiv').toggle();
        //         $('.customDatePicker').hide();
        //         $('.customMonthPicker').show();
        //     });
        // })
        // this.setState({
        //     monthView: false
        // })

        // Turn toggles off if next dates are invalid
        this.handleDateToggle('next',true);
        this.handleDateToggle('previous',true);

        // Handle tooltips
        $('[data-toggle="tooltip"]').tooltip({
            trigger: 'hover'
          });
          console.log("h");
          $('[data-toggle="tooltip"]').on('mouseleave', function () {
            $(this).tooltip('dispose');
          });
          $('[data-toggle="tooltip"]').on('click', function () {
            $(this).tooltip('dispose');
          });

    }
    componentDidUpdate(prevProps,prevState) {
        if(!moment(prevState.end).isSame(moment(this.state.end))){
            this.handleDateToggle('next',true);
            this.handleDateToggle('previous',true);
        }

    }
    updateView(startDate, endDate){
        startDate = startDate ? moment(startDate) : null
        endDate = endDate ? moment(endDate) : null

        let dateFormat = this.props.granularity == 'month' ? 'MMM YYYY' : this.props.granularity == 'date' || this.props.granularity == 'day' ? 'MMM D, YYYY' : 'MMM D, YYYY'
        if (startDate && startDate.isValid() && endDate && endDate.isValid() && !this.props.isOriginalDate) {
            $('#reportrange span').html(startDate.format(dateFormat) + ' - ' + endDate.format(dateFormat));
        } else if(this.props.pageName == "pinboard" || this.props.pageName == "globaldashboards"){
            $('#reportrange span').html("Original Date");
        }
    }
    handleDates(actualProps){
        var that = this;
        var start = actualProps.startDate ? moment(actualProps.startDate) : null;
        var end = actualProps.endDate ? moment(actualProps.endDate) : null;
                if (actualProps.pageName == "pinboard" || actualProps.pageName == "globaldashboards") {           if (actualProps.dashboardConfigDates && actualProps.dashboardConfigDates.startDate && actualProps.dashboardConfigDates.endDate)
                    if(actualProps.dashboardConfigDates.startDate!==undefined||null)
            {
                that.updateView(actualProps.startDate, actualProps.endDate)
            }else{
                that.updateView(actualProps.dashboardConfigDates.startDate, actualProps.dashboardConfigDates.endDate);
            }
             else that.updateView(start, end);
            // $('#reportrange span').html("Orginal Date");
        } else {
            that.updateView(start, end);
        }
        var startDate = '', endDate = '';
        
        //onchange start date
        $('.startDatepicker').datepicker({
            minDate: new Date(moment(minDateCalendar, "YYYY-MM-DD")),
            maxDate: new Date(moment(maxDateCalendar, "YYYY-MM-DD")),
            autoClose: true,
            startDate: new Date(start),
            dateFormat: "dd M yyyy",
            position:screen_width > mobile_width? "left center":"left center",
            onSelect: function onSelect(fd, start) {
                startDate = moment(start);
                $('.endDatepicker').datepicker({
                    minDate: new Date(moment(start))
                });
            }
        })
        //onchange start date
        $('.startMonthpicker').datepicker({
            minDate: new Date(moment(minDateCalendar, "YYYY-MM-DD")),
            maxDate: new Date(moment(maxDateCalendar, "YYYY-MM-DD")),
            autoClose: true,
            startDate: new Date(start),
            dateFormat: "M yyyy",
            position:screen_width > mobile_width? "left center":"left center",
            onSelect: function onSelect(fd, date) {
                startDate = moment(date);
                $('.endMonthpicker').datepicker({
                    minDate: new Date(moment(date))
                });
            }
        })
        //onselect end date
        $('.endDatepicker').datepicker({
            minDate: new Date(moment(minDateCalendar, "YYYY-MM-DD")),
            maxDate: new Date(moment(maxDateCalendar, "YYYY-MM-DD")),
            startDate: new Date(end),
            autoClose: true,
            position:screen_width > mobile_width? "left center":"left center",
            dateFormat: "dd M yyyy",
            onSelect: function onSelect(fd, date) {
                endDate = moment(date);
                $('.startDatepicker').datepicker({
                    maxDate: new Date(moment(date))
                });
            }
        })
        //onselect end date
        $('.endMonthpicker').datepicker({
            minDate: new Date(moment(minDateCalendar, "YYYY-MM-DD")),
            maxDate: new Date(moment(maxDateCalendar, "YYYY-MM-DD")),
            startDate: new Date(end),
            autoClose: true,
            position:screen_width > mobile_width? "left center":"left center",
            dateFormat: "M yyyy",
            onSelect: function onSelect(fd, date) {
                endDate = moment(date);
                $('.startMonthpicker').datepicker({
                    maxDate: new Date(moment(date))
                });
            }
        })

        //month and date picker toggle
        // $('.customDateClick').click(function () {
        //     pickerType = "date";
        //     $('.customDatePicker').show();
        //     $('.customMonthPicker').hide();
        // });
        // $('.customMonthClick').click(function () {
        //     pickerType = "month";
        //     $('.customDatePicker').hide();
        //     $('.customMonthPicker').css('display', 'flex');;
        // });

        $('.closeBtn').click(() =>{
            filterToggle = false
            calendarDropDown("close");
        })

        $('.applyButtonDatepicker').click(() => {
            let regexToCheck = /[~!@#$%^&*()_+\-\=\[\]{};':"\\|,.<>\/?]+/
            filtersAppliedFlag = true
            
            startDate = pickerType == "date" || pickerType == "week" || pickerType == "hour" ? moment(jQuery(".startDatepicker").val(), "D MMM YYYY") : moment(jQuery(".startMonthpicker").val(), "MMM YYYY");

            endDate = pickerType == "date" || pickerType == "week" || pickerType == "hour"  ? moment(jQuery(".endDatepicker").val(),"D MMM YYYY") : moment(jQuery(".endMonthpicker").val(),"MMM YYYY").endOf("Month");

            if ((startDate && regexToCheck.test(startDate._i)) || (endDate && regexToCheck.test(endDate._i))) {
                alert('Please enter valid inputs!')
            } else {
                if (startDate && startDate.isValid() && endDate && endDate.isValid()) {
                    this.handleCalender({ "startDate": startDate, "endDate": endDate })
                }
            }
        })

        $('.fastDateChange').click((e) => {
            let text = e.target.innerText.toLowerCase();
            switch (text) {
                case "original date":
                    var temp_start_Date = temp_end_Date = null;
                    break;
                case "last day":
                    var temp_start_Date = moment(maxDateCalendar, 'YYYY-MM-D');
                    var temp_end_Date = moment(maxDateCalendar, 'YYYY-MM-D');
                    break;
                case "last 3 day":
                    var temp_max_date = moment(maxDateCalendar, 'YYYY-MM-D').subtract(1, 'day');
                    var temp_start_Date = moment(temp_max_date, 'YYYY-MM-D').subtract(3, 'day');
                    var temp_end_Date = moment(temp_max_date, 'YYYY-MM-D');
                    break;
                case "last week":
                    // var temp_max_date = moment(maxDateCalendar, 'YYYY-MM-D').subtract(1, 'day');
                    // var temp_start_Date = moment(temp_max_date, 'YYYY-MM-D').startOf('week');
                    // var temp_end_Date = moment(temp_max_date, 'YYYY-MM-D');
                    /* Get previous weeks dates */
                    var temp_start_Date = moment(maxDateCalendar).subtract(1, 'week').startOf('week');
                    var temp_end_Date = moment(maxDateCalendar).subtract(1, 'week').endOf("week");
                    break;
                case "last 15 days":
                    var temp_max_date = moment(maxDateCalendar, 'YYYY-MM-D').subtract(1, 'day');
                    var temp_start_Date = moment(temp_max_date, 'YYYY-MM-D').subtract(15, 'day');
                    var temp_end_Date = moment(temp_max_date, 'YYYY-MM-D');
                    break;
                case "this month":
                    var temp_start_Date = moment().startOf("month");
                    var temp_end_Date = moment();
                    break;
                case "last month":
                    var temp_start_Date = moment(maxDateCalendar).subtract(1, 'month').startOf("month");
                    var temp_end_Date = moment(maxDateCalendar).subtract(1, 'month').endOf("month");
                    break;
                case "today":
                    var temp_start_Date = moment();
                    var temp_end_Date = moment();
                    break;
                case "yesterday":
                    /* Deprecation warning: moment().subtract(period, number) is deprecated. Please use moment().subtract(number, period) */
                    var temp_start_Date = moment().subtract(1,'day');
                    var temp_end_Date = moment().subtract(1,'day');
                    break;
                case "this week":
                    var temp_start_Date = moment().startOf('week').add(1,'day');
                    var temp_end_Date = moment();
                    break;
                case "last 3 months":
                    var temp_start_Date = moment(maxDateCalendar, 'YYYY-MM-D').subtract(3, 'month').startOf("month");
                    var temp_end_Date = moment(maxDateCalendar, 'YYYY-MM-D').subtract(1, 'month').endOf("month");
                    // var temp_end_Date = moment(maxDateCalendar).endOf("month");
                    // var temp_start_Date = moment().subtract('month',3).startOf("month");
                    // var temp_end_Date = moment().subtract('month',1).endOf("month");
                    break;
                case "last 6 months":
                    var temp_start_Date = moment(maxDateCalendar, 'YYYY-MM-D').subtract(6, 'month').startOf("month");
                    var temp_end_Date = moment(maxDateCalendar, 'YYYY-MM-D').subtract(1, 'month').endOf("month");
                    // var temp_end_Date = moment(maxDateCalendar).endOf("month");
                    // var temp_start_Date = moment().subtract('month',6).startOf("month");
                    // var temp_end_Date = moment().subtract('month',1).endOf("month");
                    break;
                case "last 13 month":
                    var temp_start_Date = moment(maxDateCalendar, 'YYYY-MM-D').subtract(12, 'month').startOf("month");
                    var temp_end_Date = moment(maxDateCalendar, 'YYYY-MM-D').endOf("month");
                    // var temp_start_Date = moment().subtract('month',13).startOf("month");
                    // var temp_end_Date = moment().subtract('month',1).endOf("month");
                    break;
                case "last 1 year":
                case "last 2 years":
                    var temp_start_Date = '';
                    fyMonth = parseInt(this.props.setFiscalYear);
                    if (fyMonth) {
                        let currentYear = moment(maxDateCalendar).format('YYYY');  // Get the current year
                        let currentMonth = moment(maxDateCalendar).format('MM');    // Get the current month
                        currentMonth = parseInt(currentMonth);
                        let numberToMinus = text == 'last 1 year' ? 1 : 2
                        if (currentMonth > fyMonth) {
                            currentYear = currentYear - numberToMinus;
                        } else if (currentMonth < fyMonth) {
                            currentYear = currentYear - (numberToMinus + 1)
                        }
                        // Passing 'fyMonth-1' to currentMonth because month start from 0 in moment. Ref. link https://momentjs.com/docs/#/parsing/array/
                        currentMonth = fyMonth - 1; // Always start with fyMonth
                        currentYear = parseInt(currentYear);
                        let startDate = moment([currentYear, currentMonth, 1]);
                        temp_start_Date = moment(startDate).startOf('month');   // Start of the fiscal month
                    } else {
                        temp_start_Date = moment(maxDateCalendar).startOf("year"); // Get start of the year.
                    }
                    var temp_end_Date = moment(temp_start_Date).add(text == 'last 1 year' ? 11 : 23, 'month').endOf('month')
                    // var temp_start_Date = moment(maxDateCalendar, 'YYYY-MM-D').subtract(12, 'month').startOf("month");
                    // var temp_end_Date = moment(maxDateCalendar).endOf("month");
                    // var temp_start_Date = moment().subtract('month',12).startOf("month");
                    // var temp_end_Date = moment().subtract('month',1).endOf("month");
                    break;
                case "last 2 yearss":
                    var temp_start_Date = moment(maxDateCalendar, 'YYYY-MM-D').subtract(23, 'month').startOf("month");
                    var temp_end_Date = moment(maxDateCalendar).endOf("month");
                    // var temp_start_Date = moment().subtract('month',24).startOf("month");
                    // var temp_end_Date = moment().subtract('month',1).endOf("month");
                    break;
                case "last 3 year":
                    var temp_start_Date = moment(maxDateCalendar, 'YYYY-MM-01').subtract(35, 'month').startOf("month");
                    var temp_end_Date = moment(maxDateCalendar).endOf("month");
                    // var temp_start_Date = moment().subtract('month',36).startOf("month");
                    // var temp_end_Date = moment().subtract('month',1).endOf("month");
                    break;
                case "mtd":
                    var temp_start_Date = moment(maxDateCalendar).startOf("month");
                    var temp_end_Date=moment(maxDateCalendar, 'YYYY-MM-D');
                    // var temp_end_Date = moment(maxDateCalendar).endOf("month");
                    // var temp_start_Date = moment().startOf("month");    // Get the start of current month
                    // var temp_end_Date = moment().subtract('day',1);   // Get Yesterday's date                
                    break;
                case "ytd":
                    var temp_start_Date = '';
                    fyMonth = parseInt(this.props.setFiscalYear);
                    if (fyMonth) {
                        let currentYear = moment(maxDateCalendar).format('YYYY');  // Get the current year
                        let currentMonth = moment(maxDateCalendar).format('MM');    // Get the current month
                        currentMonth = parseInt(currentMonth);
                        if (currentMonth < fyMonth) {        // If current month is < than fyMonth then go to prev year
                            currentYear = currentYear - 1;
                        }
                        // Passing 'fyMonth-1' to currentMonth because month start from 0 in moment. Ref. link https://momentjs.com/docs/#/parsing/array/
                        currentMonth = fyMonth - 1; // Always start with fyMonth
                        currentYear= parseInt(currentYear);
                        let startDate = moment([currentYear, currentMonth,1]);
                        temp_start_Date = moment(startDate).startOf('month');   // Start of the fiscal month
                    } else {
                        temp_start_Date = moment(maxDateCalendar).startOf("year"); // Get start of the year.
                    }
                    var temp_end_Date = moment(maxDateCalendar);   // Get Yesterday's date
                    break;
                case "wtd":
                    var temp_start_Date=moment(maxDateCalendar, 'YYYY-MM-D').startOf('week');
                    var temp_end_Date=moment(maxDateCalendar, 'YYYY-MM-D');
                    break;
                case "qtd":
                    var temp_start_Date=moment(maxDateCalendar, 'YYYY-MM-D').startOf('quarter');
                    var temp_end_Date=moment(maxDateCalendar, 'YYYY-MM-D');
                    break
                case "this year":
                    var temp_start_Date = '';
                    fyMonth = parseInt(fyMonth);
                    if (fyMonth) {
                        let currentYear = moment().format('YYYY');  // Get the current year
                        let currentMonth = moment().format('MM');    // Get the current month
                        currentMonth = parseInt(currentMonth);
                        if (currentMonth < fyMonth) {        // If current month is < than fyMonth then go to prev year
                            currentYear = currentYear - 1;
                        }
                        // Passing 'fyMonth-1' to currentMonth because month start from 0 in moment. Ref. link https://momentjs.com/docs/#/parsing/array/
                        currentMonth = fyMonth - 1; // Always start with fyMonth
                        let startDate = moment([currentYear, currentMonth]);
                        temp_start_Date = moment(startDate).startOf('month');   // Start of the fiscal month
                    } else {
                        temp_start_Date = moment().startOf("year"); // Get start of the year.
                    }
                    var temp_end_Date = moment();   // Get Yesterday's date
                    break;
            }
            $('#reportrange span').html(temp_start_Date.format('MM, YYYY') + ' - ' + temp_end_Date.format('MM, YYYY'));
            this.handleCalender({ "startDate": temp_start_Date.format("YYYY-MM-DD"), "endDate": temp_end_Date.format("YYYY-MM-DD") }, true)
        });
    }

    handleCalender = (date, customLastDate = false) => {
        if (alfredConfig == 'no' && this.props.allPropsData && this.props.allPropsData.state && this.props.allPropsData.state.alfred_question) {
            const url = new URL(window.location);
            const params = new URLSearchParams(url.search);
            params.delete('question');
            url.search = params.toString();
            history.replaceState(null, '', url);
            this.props.allPropsData.state.setQuestion({ alfred_question: "" })
        }
        // history.pushState({}, null, window.location.href.replace("?nav=new", ""));
        // history.pushState({}, null, window.location.href.replace("&nav=new", ""));
        // console.log('hello', granularity, customLastDate)
        jQuery('.myDropdownMenu').hide();
        if (granularity == "year") {
            endDate = moment(date["endDate"]).format('31/12/YYYY');
            startDate = moment(date["startDate"]).add(fiscalMonth - 1, 'M').format('YYYY-MM-DD');
            endDate = moment(endDate).add(fiscalMonth - 1, 'M').format('YYYY-MM-DD');
        } else if (granularity == "month") {
            endDate = moment(date["endDate"]).endOf('Month').format('YYYY-MM-DD');
            startDate = moment(date["startDate"]).format('YYYY-MM-DD');
        } else {
            startDate = moment(date["startDate"]).format('YYYY-MM-DD');
            endDate = moment(date["endDate"]).format('YYYY-MM-DD');
        }
        this.setState({ start: date["startDate"], end: date["endDate"]})
        // if(!customLastDate) $('.mainBoxDiv').toggle('hide');
        // this.props.onChange(startDate, endDate); // sending startDate and endDate to parent

        filterToggle=false;
        //pickerType="month";
        calendarDropDown("close");

        if (this.props.pageName == "pinboard" || this.props.pageName == "globaldashboards") {
            this.props.set_start_end_date({ dashboard: { "startDate": startDate, "endDate": endDate } })
        } else {
            let new_props = { "startDate": startDate, "endDate": endDate }
            let finalObj = handleParamsToSet(null, new_props, this.props.allPropsData);
            this.props.set_disp_objects({ ...finalObj, 'initialDataApiFlag': true });
            // filterHandleChangeFunction({ "startDate": startDate, "endDate": endDate })
        }
        
    }
    formSubmit(e) {
        e.preventDefault()
        return false;
    }

    filterToggleHandle(){
        if(filterToggle){
            filterToggle=false;
            console.log("closeStatusSet");
            calendarDropDown("close");
        }else{
            filterToggle=true;
            console.log("openStatusSet");
            calendarDropDown("open");
        }
        jQuery(".startMonthpicker").datepicker().data('datepicker').view="months";
        jQuery(".endMonthpicker").datepicker().data('datepicker').view="months";
        jQuery(".startDatepicker").datepicker().data('datepicker').view="days";
        jQuery(".endDatepicker").datepicker().data('datepicker').view="days";
    }

    // viewChangeHandle(){
    //     const monthPicker = document.querySelector(".customMonthPicker");
    //     const datePicker = document.querySelector(".customDatePicker");
    //     if(this.state.monthView){
    //         pickerType = "date"
    //         monthPicker.style.display="none";
    //         datePicker.style.display="flex";
    //         /* $('.customMonthPicker').hide();
    //         $('.customDatePicker').show(); */
    //     }else{
    //         pickerType = "month"
    //         monthPicker.style.display="flex";
    //         datePicker.style.display="none";
    //         /* $('.customDatePicker').hide();
    //         $('.customMonthPicker').show(); */
    //     }
    //     this.setState({
    //         monthView:!this.state.monthView
    //     })
    // }

    handleDateToggle(type,check){
        const start = $('.startDatepicker').datepicker().data('datepicker');

        const currentStartDate = moment(this.state.start);
        const currentEndDate = moment(this.state.end);
        const maxDate = moment(start.maxDate);
        const minDate = moment(start.minDate);

        let newStartDate;
        let newEndDate;

        const monthView = currentStartDate.isSame(currentStartDate.clone().startOf('month'),'day') && currentEndDate.isSame(currentEndDate.clone().endOf('month'));

        if(type==="next"){
            newStartDate = currentEndDate.clone();
            newEndDate = currentEndDate.clone();
        }
        else if(type ==="previous"){
            newStartDate = currentStartDate.clone();
            newEndDate = currentStartDate.clone();
        }

        if(monthView){
            let diff = currentEndDate.diff(currentStartDate,"month");
            diff+=1;
            if(type==="next"){ 
                newStartDate.add(1,'day').startOf('month');
                newEndDate.add(diff,'month').endOf('month');
            } 
            else if(type==="previous"){
                newStartDate.subtract(diff,'month').startOf('month');
                newEndDate.subtract(1,'day').endOf('month');
            }
        } else {
            let diff = currentEndDate.diff(currentStartDate,"d");
            diff+=1;
            if(type==="next"){ 
                newStartDate.add(1,'day');
                newEndDate.add(diff,'day');
            } 
            else if(type==="previous"){
                newStartDate.subtract(diff,'day');
                newEndDate.subtract(1,'day');
            }
        }

        if(newStartDate.isSameOrBefore(maxDate,'day') && newEndDate.isSameOrAfter(minDate,'day') && !check){
            if(newStartDate.isSameOrAfter(minDate,'day') && newEndDate.isSameOrBefore(maxDate,'day')){
                this.handleCalender({ "startDate": newStartDate, "endDate": newEndDate });
            }
            else if(newStartDate.isBefore(minDate) && newEndDate.isSameOrBefore(maxDate,'day')){
                this.handleCalender({ "startDate": minDate, "endDate": newEndDate });
            }
            else if(newStartDate.isSameOrAfter(minDate,'day') && newEndDate.isAfter(maxDate,'day')){
                this.handleCalender({ "startDate": newStartDate, "endDate": maxDate });
            }
        }

        const prevBtn = document.getElementById("calender-previous-toggle");
        const nextBtn = document.getElementById("calender-next-toggle");

        if(newStartDate.isAfter(maxDate,'day') ){
            nextBtn.style.cursor="not-allowed"
            nextBtn.disabled = true;
        }else if(newEndDate.isBefore(minDate,'day')){
            prevBtn.style.cursor="not-allowed"
            prevBtn.disabled = true;
        }else{
            if(type==="next"){
                nextBtn.style.cursor="auto"
                nextBtn.disabled = false;
            }
            else if(type==="previous"){
                prevBtn.style.cursor="auto"
                prevBtn.disabled = false;
            }
        }

        
    }

    render() {
        let newDates = null;
        if(moment(maxDateCalendar)==moment()){
            // today
            newDates = (
                <>
                    <li className="fastDateChange dropdown-item">Today</li>
                    <li className="fastDateChange dropdown-item">Yesterday</li>
                    <li className="fastDateChange dropdown-item">This Week</li>
                    <li className="fastDateChange dropdown-item">This Month</li>
                    <li className="fastDateChange dropdown-item">This Year</li>
                </>
            )
        }else if(moment(maxDateCalendar)==moment().subtract(1,'day')){
            // yesterday
            newDates = (
                <>
                    <li className="fastDateChange dropdown-item">Yesterday</li>
                    <li className="fastDateChange dropdown-item">This Week</li>
                    <li className="fastDateChange dropdown-item">This Month</li>
                    <li className="fastDateChange dropdown-item">This Year</li>
                </>
            )
        }
        let mobile = jQuery(document).width() <= 500;
        let tablet = window.screen_width <= tablet_width 
        let isGlobalFilter = this.props.globalFilters?.length > 0
        let leftMargin = "0px";
        // if (mobile) {
        //     if (window.location.pathname === "/insight") {
        //         leftMargin = "-260px";
        //     } else if (window.location.pathname === "/pinboard" && isGlobalFilter) {
        //         leftMargin = "-100px";
        //     }else if (window.location.pathname === "/pinboard") {
        //         leftMargin = "-180px";
        //     } else {
        //         leftMargin = isGlobalFilter ? "-100px" : "-95px";
        //     }
        // } else if (tablet) {
        //     leftMargin = (window.location.pathname === "/insight") ? "-260px" : "-180px";
        // } else {
        //     leftMargin = "-110px";
        // }
        return (
            
            <>
                <span id="reportrange" className="dropdown">
                    <div className={`${screen_width>mobile_width?'':''}  d-flex btn align-items-stretch btn-sm btn-white pd-0`} >
                        <button id="calender-previous-toggle" title="Previous" data-toggle="tooltip" data-placement="top" className=" Next btn-sm btn btn-white bd bd-0 pd-4 tx-12 pd-l-10 " style={{ color: "rgba(27, 46, 75, 0.7)" }} onClick={this.handleDateToggle.bind(this, "previous", false)} >
                            <i className="fa fa-chevron-left"></i>
                        </button>
                        <button  className="btn-sm btn btn-white bd bd-0 pd-x-10 text-truncate" id="calendarButton" type="div" aria-haspopup="true" aria-expanded="false" onClick={this.filterToggleHandle.bind(this)}>
                            <i className="fa fa-calendar"></i>{` `}
                            { <span></span>}
                        </button>
                        <button id="calender-next-toggle" title="Next" data-toggle="tooltip" data-placement="top" className="Previous btn-sm btn btn-white bd bd-0 pd-4 tx-12 pd-r-10" style={{ color: "rgba(27, 46, 75, 0.7)" }} onClick={this.handleDateToggle.bind(this,"next",false)} >
                            <i className="fa fa-chevron-right"></i>
                        </button>
                    </div>
                    <div className="dropdown-menu" style={{ width: "350px", marginLeft: leftMargin, marginTop: "15px", }}>
                        <div className="row">
                            <div className="col-5 mg-0" style={{maxHeight:"230px",overflow:"auto"}}>
                                <h6 className="dropdown-header tx-uppercase tx-11 tx-bold tx-inverse tx-spacing-1">Quick Options</h6>
                                {/* <li className="customDateClick dropdown-item">Custom Date</li>
                                <li className="customMonthClick dropdown-item">Month Selection</li> */}
                                {newDates}
                                {(this.props.enableWTD == "date" || this.props.enableWTD == "day")  ? (<li className="fastDateChange dropdown-item" id="date_last_WTD">WTD</li>) : null}
                                <li className="fastDateChange dropdown-item" id="date_last_MTD">MTD</li>
                                <li className="fastDateChange dropdown-item" id="date_last_QTD">QTD</li>
                                <li className="fastDateChange dropdown-item" id="date_last_YTD">YTD</li>
                                <li className="fastDateChange dropdown-item" id="date_last_week">Last Week</li>
                                <li className="fastDateChange dropdown-item" id="date_last_month">Last Month</li>
                                <li className="fastDateChange dropdown-item" id="date_last_3_month">Last 3 Months</li>
                                <li className="fastDateChange dropdown-item" id="date_last_6_month">Last 6 Months</li>
                                <li className="fastDateChange dropdown-item" id="date_last_1_year">Last 1 Year</li>
                                <li className="fastDateChange dropdown-item" id="date_last_2_year">Last 2 Years</li>

                            </div>
                            <div className="col-6 mg-0 border-left">
                                <form autoComplete="off" className="pd-y-10" onSubmit={this.formSubmit}>
                                    {/* <div className="form-group mb-1 custom-control custom-switch mg-l-5">
                                        <input type="checkbox" className="custom-control-input" id="dateView" checked={this.state.monthView} onChange={this.viewChangeHandle}/>
                                        <label className="custom-control-label tx-13" for="dateView">Enable Month View</label>
                                    </div> */}
                                    <div className="row customDatePicker">
                                        <div className="form-group mg-b-4 mg-t-8">
                                            <label htmlFor="fromcustom" className="d-block mg-b-0 pd-t-0">From</label>
                                            <input type='text' name="startDate" placeholder={moment(this.state.start).format("D MMM YYYY")} defaultValue={moment(this.state.start).format("D MMM YYYY")} className='datepicker-here startDatepicker form-control' data-language='en' data-date-format="dd M yyyy" />
                                        </div>
                                        <div className="form-group mg-b-4 mg-t-8">
                                            <label htmlFor="fromcustom" className="d-block mg-b-0 pd-t-0">To</label>
                                            <input type='text' name="endDate" placeholder={moment(this.state.end).format("D MMM YYYY")}  defaultValue={moment(this.state.end).format("D MMM YYYY")} className='datepicker-here endDatepicker form-control' data-language='en' data-date-format="dd M yyyy" />
                                        </div>
                                    </div>
                                    <div className="row customMonthPicker">
                                        <div className="form-group mg-b-4 mg-t-8">
                                            <label htmlFor="fromcustom" className="d-block mg-b-0 pd-t-0">From</label>
                                            <input type='text' name="startDate" placeholder={moment(this.state.start).format('MMM YYYY')}  className='datepicker-here startMonthpicker form-control' data-language='en' data-min-view="months" data-view="months" data-date-format="M yyyy" />
                                        </div>
                                        <div className="form-group mg-b-4 mg-t-8">
                                            <label htmlFor="fromcustom" className="d-block mg-b-0 pd-t-0">To</label>
                                            <input type='text' name="endDate" placeholder={moment(this.state.end).format('MMM YYYY')}  className='datepicker-here endMonthpicker form-control' data-language='en' data-min-view="months" data-view="months" data-date-format="M yyyy" />
                                        </div>
                                    </div>
                                    <div className="d-flex justify-content-around mg-4 mg-l-20 mg-t-10">
                                        <button className="w-50 btn btn-sm btn-primary applyButtonDatepicker mg-r-5">Apply</button>
                                        <button className="w-50 btn btn-sm btn-white closeBtn">Close</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </span>
            </>
        );
    }
};
function mapStateToProps(state) {
    return {
        globalFilters: state.dataSet.globalFilters
    }
}
function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        set_start_end_date, set_disp_objects
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(CalenderComponent);